import { connect } from 'react-redux';

import PdpStoreInventory from 'components/PdpStoreInventory';
import * as actions from 'state/actions';
import { getStoreLocationContentByHandle } from 'state/selectors/contentful';
import {
  pdpStoreInventoryModalIsOpen,
  getCurrentProduct,
  getCurrentVariant,
} from 'state/selectors/pdp';
import Customer from 'utils/Customer';
import GENERIC_CTA_CLICKED_EVENT from 'utils/Rudderstack/constants';
import { StoreLocationUtils } from 'utils/StoreLocation';

const _getStoreLocationContentByVariant = (storeLocationContent, currentVariant) => {
  if (currentVariant) {
    const storeLocationInventoryNumericId =
      StoreLocationUtils.mapShopifyLocationGraphqlIdToNumericId(currentVariant?.metafields);

    return StoreLocationUtils.mapShopifyLocationIdWithContentHandle(
      storeLocationContent,
      storeLocationInventoryNumericId
    );
  } else {
    return {};
  }
};

const _defaultSortedList = storeLocationContentByVariant =>
  Object.keys(storeLocationContentByVariant)
    .sort()
    .map(key => ({ handle: key }));

const mapStateToProps = state => {
  const isModalOpen = pdpStoreInventoryModalIsOpen(state);
  const product = getCurrentProduct(state);
  const variant = getCurrentVariant(state);
  const preferredStoreHandle = Customer.preferredStore;
  const storeLocationContent = getStoreLocationContentByHandle(state);
  const storeLocationContentByVariant = _getStoreLocationContentByVariant(
    storeLocationContent,
    variant
  );
  const defaultSortedList = _defaultSortedList(storeLocationContentByVariant);

  return {
    isModalOpen,
    product,
    variant,
    preferredStoreHandle,
    storeLocationContentByVariant,
    defaultSortedList,
  };
};

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(actions.closeModal()),
  openModal: copy => {
    dispatch(actions.openStoreInventoryModal());
    dispatch(
      actions.trackPdpStoreInventoryDropdownAction(
        GENERIC_CTA_CLICKED_EVENT.TYPES.LINK,
        'Find a store',
        copy
      )
    );
  },
  dropdownToggled: () =>
    dispatch(
      actions.trackPdpStoreInventoryDropdownAction(
        GENERIC_CTA_CLICKED_EVENT.TYPES.ICON,
        'Dropdown Toggled',
        null
      )
    ),
  callToReserveClicked: storeHandle =>
    dispatch(
      actions.trackPdpStoreInventoryDropdownAction(
        GENERIC_CTA_CLICKED_EVENT.TYPES.BUTTON,
        'Call to Reserve',
        storeHandle
      )
    ),
  storeSelected: storeHandle =>
    dispatch(
      actions.trackPdpStoreInventoryModalAction(
        GENERIC_CTA_CLICKED_EVENT.TYPES.BUTTON,
        'Select Location',
        storeHandle
      )
    ),
  storeSaved: storeHandle =>
    dispatch(
      actions.trackPdpStoreInventoryModalAction(
        GENERIC_CTA_CLICKED_EVENT.TYPES.BUTTON,
        'Save Preferred Store',
        storeHandle
      )
    ),
  searchCompleted: query =>
    dispatch(
      actions.trackPdpStoreInventoryModalAction(
        GENERIC_CTA_CLICKED_EVENT.TYPES.SEARCH,
        'Store Search',
        query
      )
    ),
  setPreferredStore: storeHandle => Customer.setPreferredStore(storeHandle),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(PdpStoreInventory);
